// JSX Images
import SugarVariant from "../../components/quiz/images/sugar-variant";
import ColorBottles from "../../components/quiz/images/color-bottles";
import TypesBottles from "../../components/quiz/images/types-bottles";
import Glass from "../../components/quiz/images/glass";
import { UI_ASSETS_BASE_URL } from "~/constants/assets";

const glassOfWhite = `${UI_ASSETS_BASE_URL}/quiz/glass-of-white.svg`;
const glassOfRed = `${UI_ASSETS_BASE_URL}/quiz/glass-of-red.svg`;
const glassOfRose = `${UI_ASSETS_BASE_URL}/quiz/glass-of-rose.svg`;
const acidic = `${UI_ASSETS_BASE_URL}/quiz/flavors/acidic.png`;
const butterFlavor = `${UI_ASSETS_BASE_URL}/quiz/flavors/butter.png`;
const citrus = `${UI_ASSETS_BASE_URL}/quiz/flavors/citrus.png`;
const crisp = `${UI_ASSETS_BASE_URL}/quiz/flavors/crisp.png`;
const floral = `${UI_ASSETS_BASE_URL}/quiz/flavors/floral.png`;
const fruit = `${UI_ASSETS_BASE_URL}/quiz/flavors/fruit.png`;
const mineral = `${UI_ASSETS_BASE_URL}/quiz/flavors/mineral.png`;
const oak = `${UI_ASSETS_BASE_URL}/quiz/flavors/oak.png`;
const tannic = `${UI_ASSETS_BASE_URL}/quiz/flavors/tannic.png`;
const almonds = `${UI_ASSETS_BASE_URL}/quiz/foods/almonds.png`;
const blackCoffee = `${UI_ASSETS_BASE_URL}/quiz/foods/black-coffee.png`;
const butteredToast = `${UI_ASSETS_BASE_URL}/quiz/foods/buttered-toast.png`;
const caramelFrappuccino = `${UI_ASSETS_BASE_URL}/quiz/foods/caramel-frappuccino.png`;
const greenOlives = `${UI_ASSETS_BASE_URL}/quiz/foods/green-olives.png`;
const keyLimePie = `${UI_ASSETS_BASE_URL}/quiz/foods/key-lime-pie.png`;
const mushrooms = `${UI_ASSETS_BASE_URL}/quiz/foods/mushrooms.png`;
const pinaColada = `${UI_ASSETS_BASE_URL}/quiz/foods/pina-colada.png`;
const tarteLemonade = `${UI_ASSETS_BASE_URL}/quiz/foods/tarte-lemonade.png`;

export const styleOptions = [
  {
    id: "napa-cabernet-sauvignon",
    name: "Napa Cabernet Sauvignon",
    imageSrc: glassOfRed,
    imageAltText: "Image, icon of a glass of Napa Cabernet Sauvignon",
    label: "Napa",
    sublabel: "Cabernet Sauvignon",
    color: "red",
  },
  {
    id: "cali-oaky-chardonnay",
    name: "Oaky California Chardonnay",
    imageSrc: glassOfWhite,
    imageAltText: "Image, icon of a glass of Oaky California Chardonnay",
    label: "Oaky California",
    sublabel: "Chardonnay",
    color: "white",
  },
  {
    id: "argentina-malbec",
    name: "Argentinian Malbec",
    imageSrc: glassOfRed,
    imageAltText: "Image, icon of a glass of Argentinian Malbec",
    label: "Argentinian",
    sublabel: "Malbec",
    color: "red",
  },
  {
    id: "italy-pinot-grigio",
    name: "Italian Pinot Grigio",
    imageSrc: glassOfWhite,
    imageAltText: "Image, icon of a glass of Italian Pinot Grigio",
    label: "Italian",
    sublabel: "Pinot Grigio",
    color: "white",
  },
  {
    id: "aus-shiraz",
    name: "Australian Shiraz",
    imageSrc: glassOfRed,
    imageAltText: "Image, icon of a glass of Australian Shiraz",
    label: "Australian",
    sublabel: "Shiraz",
    color: "red",
  },
  {
    id: "nz-sauvignon-blanc",
    name: "New Zealand Sauvignon Blanc",
    imageSrc: glassOfWhite,
    imageAltText: "Image, icon of a glass of New Zealand Sauvignon Blanc",
    label: "New Zealand",
    sublabel: "Sauvignon Blanc",
    color: "white",
  },
  {
    id: "oregon-pinot-noir",
    name: "Oregon Pinot Noir",
    imageSrc: glassOfRed,
    imageAltText: "Image, icon of a glass of Oregon Pinot Noir",
    label: "Oregon",
    sublabel: "Pinot Noir",
    color: "red",
  },
  {
    id: "bordeaux-red",
    name: "Bordeaux Red",
    imageSrc: glassOfRed,
    imageAltText: "Image, icon of a glass of Bordeaux Red",
    label: "Bordeaux",
    sublabel: "Red",
    color: "red",
  },
  {
    id: "sweet-riesling",
    name: "Sweet Riesling",
    imageSrc: glassOfWhite,
    imageAltText: "Image, icon of a glass of Sweet Riesling",
    label: "Sweet",
    sublabel: "Riesling",
    color: "white",
  },
  {
    id: "sweet-red",
    name: "Sweet Red Blends",
    imageSrc: glassOfRed,
    imageAltText: "Image, icon of a glass of Sweet Red Blends",
    label: "Sweet",
    sublabel: "Red Blends",
    color: "red",
  },
];

export const pairingsOptions = [
  {
    id: "almonds",
    name: "A bowl of almonds",
    imageSrc: almonds,
    label: "Almonds",
  },
  {
    id: "mushrooms",
    name: "Mushrooms, the funkier the better",
    imageSrc: mushrooms,
    label: "Mushrooms",
  },
  {
    id: "key-lime-pie",
    name: "Key Lime Pie",
    imageSrc: keyLimePie,
    label: "Key Lime Pie",
  },
  {
    id: "butter",
    name: "Butter on everything",
    imageSrc: butteredToast,
    label: "Buttered Toast",
  },
  {
    id: "green-olives",
    name: "Brined olives",
    imageSrc: greenOlives,
    label: "Green Olives",
  },
  {
    id: "black-coffee",
    name: "Black coffee",
    imageSrc: blackCoffee,
    label: "Black Coffee",
  },
  {
    id: "lemonade",
    name: "Lemonade so tart it burns",
    imageSrc: tarteLemonade,
    label: "Tart Lemonade",
  },
  {
    id: "pina-colada",
    name: "Pina Colada",
    imageSrc: pinaColada,
    label: "Piña Coladas",
  },
  {
    id: "caramel-frappuccino",
    name: "Frappuccino w/ extra caramel",
    imageSrc: caramelFrappuccino,
    label: "Caramel Frappuccinos",
  },
];

export const attributesOptions = [
  {
    id: "oak",
    name: "Oaky",
    imageSrc: oak,
    imageAltText: "Wood",
    label: "Oak",
    sublabel: "Toasted vanilla and spices",
  },
  {
    id: "butter",
    name: "Buttery",
    imageSrc: butterFlavor,
    imageAltText: "Butter",
    label: "Butter",
    sublabel: "Balanced and smooth",
  },
  {
    id: "flower",
    name: "Flowery",
    imageSrc: floral,
    imageAltText: "White flowers",
    label: "Floral",
    sublabel: "Aromatic and fresh",
  },
  {
    id: "citrus",
    name: "Citrusy",
    imageSrc: citrus,
    imageAltText: "Oranges and lemons",
    label: "Citrus",
    sublabel: "Bright and zesty",
  },
  {
    id: "mineral",
    name: "Minerality",
    imageSrc: mineral,
    imageAltText: "Mineral",
    label: "Mineral",
    sublabel: "Clean and earthy",
  },
  {
    id: "fruit",
    name: "Fruity",
    imageSrc: fruit,
    imageAltText: "Strawberries, blueberries, blackberries, and juice",
    label: "Fruit",
    sublabel: "Fresh and juicy",
  },
  {
    id: "crisp",
    name: "Crisp",
    imageSrc: crisp,
    imageAltText: "Cucumber and lemon water in a pitcher",
    label: "Crisp",
    sublabel: "Refreshing and light",
  },
  {
    id: "tannic",
    name: "Tannic",
    imageSrc: tannic,
    imageAltText: "A teacup with tea",
    label: "Tannic",
    sublabel: "Lightly bitter and dry",
  },
  {
    id: "acid",
    name: "Acidity",
    imageSrc: acidic,
    imageAltText: "Lemons",
    label: "Acidic",
    sublabel: "Citrusy and zesty",
  },
];

export const roseOptions = [
  {
    id: "rose",
    name: "Rosé",
    imageSrc: glassOfRose,
    imageAltText: "Image, icon of glass of rosé",
    label: "Rosé",
  },
];
/*
 * IMPORTANT NOTE
 * rating question's options have a name attribute that may or may not match the label, this name
 * attribute is used to map with the rec engine so it is VERY important that it stays as it is.
 */

export const questions = [
  {
    id: "color",
    type: "slider",
    title: "Do you usually drink red, white or both?",
    subtitle: "We'll ask about rosé in a bit!",
    labels: ["White", "Both", "Red"],
    Image: ColorBottles,
  },
  {
    id: "sweetness",
    type: "slider",
    title: "How sweet do you like your wine?",
    subtitle: "Move the slider to indicate your general preference.",
    labels: ["Dry", "", "Sweet"],
    Image: SugarVariant,
  },
  {
    id: "styles",
    type: "rating",
    title: "What do you think about these types of wine?",
    subtitle: "It is okay if you are not sure or neutral about some of them.",
    options: styleOptions,
  },
  {
    id: "adventurousness",
    type: "slider",
    title: "How adventurous are you when you look for wine?",
    subtitle:
      "Your response will determine how much variation we will include in your profile.",
    labels: ["Cautious", "A little", "Adventurous"],
    Image: TypesBottles,
  },
  {
    id: "expertise",
    type: "slider",
    title: "Where are you on your wine journey?",
    subtitle: "Tell us how much you know about your wine preferences.",
    labels: ["Beginning", "In between", "Expert"],
    Image: Glass,
  },
  {
    id: "pairings",
    type: "rating",
    title: "Do you like these foods?",
    subtitle: "These flavors will help us home in on your taste profile.",
    options: pairingsOptions,
  },
  {
    id: "attributes",
    type: "rating",
    title: "How do you feel about these flavors in your wine?",
    subtitle: "It is okay if you are not sure or neutral about some of them.",
    options: attributesOptions,
  },
  {
    id: "rose",
    type: "rating",
    title: "Do you like rosé?",
    subtitle: "If you do, we will make Rosé part of your preferences.",
    options: roseOptions,
  },
];

const defaultValue = (option) => ({
  id: option.id,
  name: option.name,
  value: 0,
});

// Brand questions was removed from Quiz but we are still sending the default values to recommendations request
const competitorOptions = [
  {
    id: "robert-mondavi-cabernet-sauvignon",
    name: "Robert Mondavi Cabernet Sauvignon",
  },
  {
    id: "prisoner-red",
    name: "Prisoner Red Blend",
  },
  {
    id: "flowers-chardonnay",
    name: "Flowers Chardonnay",
  },
  {
    id: "layer-cake-shiraz",
    name: "Layer Cake Shiraz",
  },
  {
    id: "jordan-cabernet-sauvignon",
    name: "Jordan Cabernet Sauvignon",
  },
  {
    id: "chateau-ste-michelle-riesling",
    name: "Chateau Ste. Michelle Riesling",
  },
  {
    id: "menage-a-trois-cali-red",
    name: "Menage a Trois California Red",
  },
  {
    id: "yellow-tail-pinot-grigio",
    name: "Yellow Tail Pinot Grigio",
  },
  {
    id: "barefoot-moscato",
    name: "Barefoot Moscato",
  },
];

export const defaultAnswers = {
  version: 2.0,
  color: 50,
  sweetness: 50,
  styles: questions.find((q) => q.id === "styles").options.map(defaultValue),
  adventurousness: 50,
  expertise: 50,
  frequency: 50,
  competitors: competitorOptions.map(defaultValue),
  pairings: questions
    .find((q) => q.id === "pairings")
    .options.map(defaultValue),
  attributes: questions
    .find((q) => q.id === "attributes")
    .options.map(defaultValue),
  rose: questions.find((q) => q.id === "rose").options.map(defaultValue),
};

// TODO: Replace experimentDefaultAnswers with defaultAnswers when the experiment is finished
export const experimentDefaultAnswers = {
  ...defaultAnswers,
  rose: 0,
};

// Trigger logic
/*
  For Slider Questions:
    Each question defined by the id has an array of rules.
    Each rule has a value that is an array of two items, lower value and upper value.
    Between those two values it will trigger the tooltip.

  For Rating Questions:
    Each question defined by the id has an object with numbers as keys that represent each card.
    Each of these keys have an array of rules.
    Each rule has a value that is an array of values that will trigger the tooltip
 */

export const feedbackTriggers = {
  color: [
    {
      value: [0, 100],
      text: "<span>Great!</span> This will help us build your box.",
    },
  ],
  styles: {
    1: [
      {
        value: [-1],
        text: "<span>Noted</span>, we will keep this in mind as we build your box.",
      },
      { value: [0], text: "Not being sure is not a problem." },
      {
        value: [1],
        text: "Great, we will keep the flavor profile of wines like this in mind!",
      },
    ],
  },
  expertise: [
    { value: [0, 33], text: "We will guide you to your perfect wines!" },
    { value: [34, 66], text: "That is the perfect time to explore new wines!" },
    {
      value: [67, 100],
      text: "Our exclusive selections will keep things interesting!",
    },
  ],
  pairings: {
    6: [{ text: "Your personalized box is almost complete!" }],
  },
  attributes: {
    1: [
      {
        value: [-1],
        text: "<span>Noted</span>, we will avoid this as we build your box.",
      },
      {
        value: [0],
        text: "Not a problem, we will help you discover what you like.",
      },
      {
        value: [1],
        text: "<span>Great!</span>, we will have lots of wine with this flavor note for you to try!",
      },
    ],
  },
};

export default questions;
